<template>
  <div class="filterResult">
    <div class="header">
      <slot name="title">
        <el-button
          type="text"
          slot="reference"
          style="color: #4A4A4A;"
        >
          搜索内容
          <!--<i class="el-icon&#45;&#45;right el-icon-arrow-down dropDown" :class="active && 'active'" ></i>-->
        </el-button>
      </slot>
    </div>
    <el-collapse-transition>
      <div
        v-show="active"
        class="filterCardList"
      >
        <span
          v-for="(item, index) in fileData"
          :key="index"
        >
          <span
            v-if="
              Array.isArray(getName(item)) && item.tagName !== 'sky-range-input'
            "
            :data-id="getName(item)"
          >
            <el-tag
              class="tag"
              size="medium"
              :closable="!item.disableClose"
              v-for="(tag, index) in getName(item)"
              :key="index"
              @close="close(item, index)"
            >
              {{ tag }}</el-tag>
          </span>
          <span v-else>
            <el-tag
              class="tag"
              size="medium"
              @close="close(item)"
              :closable="!item.disableClose"
            >{{ getName(item) }}</el-tag>
          </span>
        </span>
      </div>
    </el-collapse-transition>
  </div>
</template>
<script>
import setTag from './tagConf.js'
import _ from 'lodash'

export default {
  props: {
    data: Array
  },
  data() {
    return {
      active: true
    }
  },
  computed: {
    fileData() {
      let that = this
      let val = that.data.filter(item => {
        return that.getName(item) != ''
          ? Array.isArray(that.getName(item))
            ? item.value.length !== 0
            : !!that.getName(item)
          : false
      })
      return val
    }
  },
  methods: {
    getName(item) {
      let tag = setTag
      return tag[item.tagName] ? tag[item.tagName]['getName'](item) : []
    },
    close(item, index) {
      let tag = setTag
      this.$emit('close', item)
      return tag[item.tagName] ? tag[item.tagName]['remove'](item, index) : []
    },
    getTag(item, index) {
      const formatList = [
        'el-radio',
        'el-select',
        'el-checkbox',
        'sky-radio',
        'sky-select',
        'sky-filterSelect',
        'sky-dropdownSelect',
        'sky-mainInput'
      ]
      let list = []
      let tag = ''
      if (item.tagName === 'sky-range-input') {
        return (
          item.label + '：' + item.value.join('-').replace(/(^-)|(-$)/g, '')
        )
      }
      if (formatList.indexOf(item.tagName) === -1) {
        return item.label + '： ' + item.value
      }
      if (typeof index !== 'undefined') {
        list = _.map(item.value, val => {
          _.each(item.options, option => {
            if (option.value === val) {
              tag = option.label
            }
          })
          return item.label + '： ' + tag
        })
        return list[index]
      } else {
        _.each(item.options, option => {
          if (option.value === item.value) {
            tag = option.label
          }
        })
        return item.label + '： ' + tag
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.filterResult {
  padding: 0 30px;
  margin-bottom: 10px;
  .header {
    display: flex;
    justify-content: space-between;
    line-height: 40px;
    .el-button--text {
      font-weight: 600;
      .el-icon--right {
        font-weight: 600;
      }
    }
  }
}

.dropDown {
  transition: transform 0.3s;
  transform: rotate(0deg);
}

.dropDown.active {
  transform: rotate(-180deg);
}

.tag {
  margin: 5px 10px 5px 0;
}
</style>
